import { Link } from "react-router-dom";
import { ArrowUpRight, Zap, Wind, ShieldCheck, Wrench } from "lucide-react";
import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

export const TRADE_ICONS = { Zap, Wind, ShieldCheck, Wrench };

export default function TradeCard({ trade, className = "" }) {
    const Icon = TRADE_ICONS[trade.icon] || Zap;
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.05 }}
            className={className}
        >
            <Link
                data-testid={`trade-card-${trade.code}`}
                to={`/services#trade-${trade.code}`}
                className="group relative flex h-full min-h-[340px] flex-col justify-end overflow-hidden rounded-2xl border border-white/10 bg-panel md:min-h-[420px]"
            >
                <img
                    src={trade.image}
                    alt={trade.title}
                    loading="lazy"
                    className="card-img absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/40 to-transparent" />
                <span
                    className="absolute bottom-0 left-0 h-full w-[3px] opacity-70 transition-opacity duration-300 group-hover:opacity-100"
                    style={{ background: trade.accent }}
                />
                <ArrowUpRight
                    size={22}
                    className="absolute right-5 top-5 -translate-y-1 translate-x-1 text-white opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:opacity-100"
                />
                <div className="relative p-6 md:p-8">
                    <div className="flex items-center gap-3">
                        <span
                            className="rounded-full border px-2.5 py-1 font-mono text-[11px] tracking-[0.18em]"
                            style={{
                                color: trade.accent,
                                borderColor: `${trade.accent}55`,
                                background: `${trade.accent}14`,
                            }}
                        >
                            NACE {trade.code}
                        </span>
                        <Icon size={16} style={{ color: trade.accent }} />
                    </div>
                    <h3 className="mt-4 max-w-md font-display text-xl font-semibold tracking-tight text-white md:text-2xl">
                        {trade.title}
                    </h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-300">
                        {trade.tagline}
                    </p>
                </div>
            </Link>
        </motion.div>
    );
}
